function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.61 2.09a2.21 2.21 0 00-.8-.67 2.44 2.44 0 00-1.13-.26 2.64 2.64 0 00-.68.09 1.89 1.89 0 00-.62.29 1.64 1.64 0 00-.46.5 1.41 1.41 0 00-.17.72 1.32 1.32 0 00.16.68 1.46 1.46 0 00.43.46 2.74 2.74 0 00.66.33l.79.27q.5.16 1 .35a3.69 3.69 0 01.94.52 2.55 2.55 0 01.69.81 2.52 2.52 0 01.27 1.22 2.92 2.92 0 01-.29 1.34 2.74 2.74 0 01-.76.94 3.24 3.24 0 01-1.1.55 4.55 4.55 0 01-1.28.18 4.67 4.67 0 01-1.81-.36A3.6 3.6 0 010 9l1.08-.91a2.69 2.69 0 002.21 1.14 2.58 2.58 0 00.7-.1 2 2 0 00.64-.31 1.69 1.69 0 00.47-.53 1.5 1.5 0 00.18-.76 1.38 1.38 0 00-.19-.75 1.67 1.67 0 00-.51-.51 3.43 3.43 0 00-.75-.36l-.9-.3A7.81 7.81 0 012 5.27a3.26 3.26 0 01-.83-.52A2.39 2.39 0 01.57 4a2.63 2.63 0 01-.22-1.17 2.54 2.54 0 01.3-1.27 2.73 2.73 0 01.79-.89A3.27 3.27 0 012.53.16 4.77 4.77 0 013.75 0a4.27 4.27 0 011.63.31 3.23 3.23 0 011.22.83z",
  fill: "#d2d2d2",
  className: "svg-no-adaptive-fill"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.53,
  cy: 5.21,
  r: 3.14
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6.69 10.42"
  }, props), _ref, _ref2);
};

export default SvgComponent;